import { ref } from "vue";
import { createInflight, writeKey } from "./inflight.js";

var TOKEN_KEY = "bed.apiToken";

function authHeader() {
	var t = localStorage.getItem(TOKEN_KEY);
	return t ? { "Authorization": "Bearer " + t } : {};
}

// The server rejected our token (changed, or never set on this device) —
// bounce to the login page so the user can re-enter it via their password
// manager. Dynamic import because router.js imports the views, which import
// this file: a static import would be a cycle.
function redirectToLogin() {
	import("./router.js").then((m) => {
		var router = m.default;
		if (router.currentRoute.value.name !== "login") {
			router.push({ name: "login" });
		}
	});
}

// True once a request the person started has taken over 300 ms; App.vue shows
// the working bar while it is.
export var working = ref(false);
var inflight = createInflight((v) => { working.value = v; }, 300);

// opts.background: a request nobody tapped for (polling), which never shows the bar.
function request(method, url, body, opts) {
	return inflight.run(writeKey(method, url, body), !!opts?.background, () => send(method, url, body));
}

async function send(method, url, body) {
	var headers = { "Content-Type": "application/json", ...authHeader() };
	var opts = { method, headers };
	if (body !== undefined) { opts.body = JSON.stringify(body); }
	var res = await fetch(url, opts);
	var text = await res.text();
	var data = text ? JSON.parse(text) : null;
	if (!res.ok) {
		var err = new Error((data && data.error) || ("HTTP " + res.status));
		err.status = res.status;
		err.data = data;
		if (res.status === 401) { redirectToLogin(); }
		throw err;
	}
	return data;
}

export var api = {
	get(url, opts) { return request("GET", url, undefined, opts); },
	put(url, body) { return request("PUT", url, body); },
	post(url, body) { return request("POST", url, body); },
	del(url) { return request("DELETE", url); },

	getToken() { return localStorage.getItem(TOKEN_KEY) ?? ""; },
	setToken(t) {
		if (t) { localStorage.setItem(TOKEN_KEY, t); }
		else { localStorage.removeItem(TOKEN_KEY); }
	},
};
